import { Component, Input } from '@angular/core';
import { BaseConfirmationDialogComponent } from '../../../../lib/components/dialogs/base-confirmation-dialog.component';

@Component({
  selector: 'boi-soft-credit-warning-dialog',
  templateUrl: './soft-credit-warning-dialog.component.html',
  styleUrls: ['./soft-credit-warning-dialog.component.scss']
})
export class SoftCreditWarningDialogComponent extends BaseConfirmationDialogComponent<void> {
  @Input() warningLabel = this.referenceDataLabels.BOSoftCreditWarning;
  @Input() warningContentLabel = this.referenceDataLabels.BOSoftCreditWarningContent;
}
